import { vFullscreenImagePlugin } from "./v-fullscreen-image";

export function fullscreenImagePlugin(app) {
  app.directive('fullscreen-image', vFullscreenImagePlugin)
}
